export default __webpack_public_path__ + "static/media/remove.d5ab0b1e.svg";